import { Button } from '../../components/ui/button';
import Fancybox from '../../lib/FancyBox';
import { FileArrowDownIcon, VideoCameraIcon } from '@phosphor-icons/react';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export default function MentorshipSessions({ packId }) {
  const navigate = useNavigate();
  const [sessionRecordings, setSessionRecordings] = useState([]);
  const [isPurchased, setIsPurchased] = useState(true);
  const user = JSON.parse(localStorage.getItem('userProfile'));

  useEffect(() => {
    async function fetchData() {
      try {
        const purchaseResponse = await axios.get(`/api/packs/${packId}/is-purchased`);
        const isPurchasedData = purchaseResponse?.data?.data?.isPurchased;
        if (!isPurchasedData) return;
        setIsPurchased(isPurchasedData);
        if (!isPurchasedData) return;
        const res = await axios.get(`/api/packs/${packId}/session-recordings`);
        const response = res?.data?.data;
        if (response) {
          setSessionRecordings(response);
        }
      } catch (error) {}
    }
    fetchData();
  }, [packId]);

  const sendWebengageEvent = (item) => {
    window.webengage.track('Watched Session Recording', {
      'User Id': user?.email,
      'Pack Id': packId,
      'Session Title': item.title,
      'Session Id': item._id,
    });
  };

  if (!isPurchased) navigate('/v2/home');

  return (
    <div className="flex flex-col gap-4">
      {sessionRecordings?.map((item) => (
        <div className="flex flex-row items-center justify-between w-full bg-[var(--q3-surface-default) border border-[var(--q3-stroke-normal)]] rounded-xl p-3">
          <div className="flex flex-row items-center">
            <VideoCameraIcon size={20} className="text-[var(--q3-danger-normal)] mx-4" />
            <div className="flex flex-col gap-2">
              <p className="font-medium">{item.title}</p>
              <p className="text-[var(--q3-neutral-light)] text-xs">{item.description}</p>
              <div className="lg:hidden flex flex-row gap-2">
                {item.pdfLink && (
                  <Button
                    variant={'outline'}
                    className={'flex flex-row !bg-[var(--q3-surface-default)] rounded-full'}
                    onClick={() => window.open(item.pdfLink, '_blank')}
                  >
                    <FileArrowDownIcon className="text-[var(--q3-danger-normal)]" />
                    PDF
                  </Button>
                )}
                <Fancybox>
                  <a
                    href={`https://www.youtube.com/embed/${item.recordingVideoId}`}
                    data-fancybox
                    data-type="iframe"
                    className="relative block w-fit overflow-hidden"
                    onClick={() => sendWebengageEvent(item)}
                  >
                    <Button variant={'outline'} className={'!bg-[var(--q3-surface-default)] rounded-full'}>
                      Watch Recording
                    </Button>
                  </a>
                </Fancybox>
              </div>
            </div>
          </div>
          <div className="hidden lg:flex flex-row gap-2">
            {item.pdfLink && (
              <Button
                variant={'outline'}
                className={'flex flex-row !bg-[var(--q3-surface-default)] rounded-full'}
                onClick={() => window.open(item.pdfLink, '_blank')}
              >
                <FileArrowDownIcon className="text-[var(--q3-danger-normal)]" />
                PDF
              </Button>
            )}
            <Fancybox>
              <a
                href={`https://www.youtube.com/embed/${item.recordingVideoId}`}
                data-fancybox
                data-type="iframe"
                className="relative block w-fit overflow-hidden"
                onClick={() => sendWebengageEvent(item)}
              >
                <Button variant={'outline'} className={'!bg-[var(--q3-surface-default)] rounded-full'}>
                  Watch Recording
                </Button>
              </a>
            </Fancybox>
          </div>
        </div>
      ))}
    </div>
  );
}
